function header() {


    // media query event handler
    if (matchMedia) {
        const mq = window.matchMedia('(min-width: 990px)');
        WidthChange(mq);

        mq.addListener(WidthChange);


        // mq.addEventListener("change", () => {
        //     WidthChange(mq);
        // });
    }

// media query change
    function WidthChange(mq) {
        $('.header__menu .nav-link').unbind();
        $('.menu--toggle').unbind();
        $('.header__menu .nav-link').unbind();

        var $body = $('body');
        var $dropdown = $('.dropdown--locations');

        $dropdown
            .on('focusin', 'input', function () {
                $dropdown.addClass('show');
            })
            .on('focusout', 'input', function () {
                $dropdown.removeClass('show');
            });


        if (mq.matches) {
            $('.header__menu .nav-link').hover((e) => {
                if ($(e.target).parent().hasClass('menu-item-has-children')) {
                    e.preventDefault();
                    const dropdownClass = $(e.target).parent()[0].classList[1];
                    const dropdown = '.dropdown--' + dropdownClass;
                    $(dropdown).addClass('show');
                    $(dropdown + ' .dropdown__menu').addClass('show');
                    $('.dropdown__overlay').addClass('show');


                    $('.secondary__content').addClass('show');
                    $('.secondary__menu').removeClass('show');
                }

            }, (e) => {
                if ($(e.target).parent().hasClass('menu-item-has-children')) {
                    $('.dropdown').removeClass('show');
                    $('.dropdown__overlay').removeClass('show');
                }
            });

            // This handles the hovering of the google autocomplete container


            $('.dropdown__menu .nav-drop-item').hoverIntent((e) => {
                if ($(e.target).parent().hasClass('secondary__trigger')) {
                    $('.secondary__menu').removeClass('show');
                    $('.secondary__content').removeClass('show');
                    const menu = $(e.target).parent()[0].classList[2].split('--')[1];
                    $('.secondary__menu--' + menu).addClass('show');
                } else {
                    $('.secondary__menu').removeClass('show');
                    $('.secondary__content').addClass('show')
                }

            });

        } else {
            // the width of browser is less then 700px

            $('.menu--toggle').on('click', () => {
                if ($('.nav-main').hasClass('show')) {
                    $('.nav-main').removeClass('show');
                    $('.buttons-container').removeClass('show');
                    $('.nav-main').removeClass('dropdown--active');
                    $('.buttons-container').removeClass('dropdown--active');
                    $('.secondary__content').removeClass('show');
                    $('.dropdown__menu').removeClass('show');
                    $('.dropdown').removeClass('show');
                    $('.menu--toggle i').removeClass('icon-cancel');
                    $('.menu--toggle i').addClass('icon-menu');

                } else {
                    $('.nav-main').toggleClass('show');
                    $('.buttons-container').toggleClass('show');
                    $('.menu--toggle i').removeClass('icon-menu');
                    $('.menu--toggle i').addClass('icon-cancel');
                }
            });

            $('.header__menu .nav-link').on('click', (e) => {
                if ($(e.target).parent().hasClass('menu-item-has-children')) {
                    e.preventDefault();
                    const dropdownClass = $(e.target).parent()[0].classList[1];
                    const dropdown = '.dropdown--' + dropdownClass;
                    $(dropdown).addClass('show');
                    $(dropdown + ' .dropdown__menu').addClass('show');

                    $('.secondary__content').addClass('show');
                    $('.nav-main').addClass('dropdown--active');
                    $('.buttons-container').addClass('dropdown--active');

                }
            });

            $('.dropdown__menu .nav-drop-item').on('click', e => {
                if ($(e.target).parent().hasClass('secondary__trigger')) {
                    e.preventDefault();
                    const secondaryClass = $(e.target).parent()[0].classList[2].split('--')[1];
                    const secondary = $('.secondary__menus .secondary__menu--' + secondaryClass);
                    secondary.addClass('show');
                    $('.secondary__content').removeClass('show');
                    $('.dropdown__menu').removeClass('show')
                }
            });

            $('.back-arrow--primary').on('click', () => {
                $('.secondary__content').removeClass('show');
                $('.nav-main').removeClass('dropdown--active');
                $('.buttons-container').removeClass('dropdown--active');

                $('.dropdown__menu').removeClass('show');
                $('.dropdown').removeClass('show');
            });

            $('.secondary__menu .back-arrow').on('click', (e) => {
                $('.secondary__menu').removeClass('show');
                const dropdownClass = $(e.target).parent()[0].classList[1].split('--')[1];
                const dropdown = '.dropdown--' + dropdownClass;
                $(dropdown).addClass('show');
                $(dropdown + ' .dropdown__menu').addClass('show');

                $('.secondary__content').addClass('show');
            });

            $('.account-menu').on('click', () => {
                $(".account-menu__dropdown").toggleClass('visible');
            });
        }


    }

}